/**
 * Cart Drawer Redirection Logic
 * Handles redirecting /cart to homepage and opening cart drawer
 */

// Theme body initialization
document.addEventListener('DOMContentLoaded', function() {
  const themeBody = document.getElementById('theme_body');
  if (themeBody) {
    themeBody.classList.add('show-theme-body');
  }
});

// Check if URL contains "/cart" and open cart drawer
if (window.location.href.indexOf('/cart') > -1) {
  // Set flag to open cart drawer after redirect
  sessionStorage.setItem('openCartDrawer', 'true');
  // Redirect to homepage if we're on the cart page
  if (window.location.pathname === '/cart') {
    window.location.href = '/';
  }
}

// Function to open cart drawer after page is fully loaded
function openCartDrawerWhenReady() {
  const drawer = document.getElementById('CartDrawerContainer');
  if (drawer) {
    drawer.classList.add('active');
    // Update URL to show cart_open without refreshing the page
    if (window.location.pathname !== '/cart_open') {
      history.pushState({}, '', '/cart_open');
    }
  }
}

// Wait for the window to fully load before checking URL parameters
window.addEventListener('load', function() {
  // Check for URL parameter open_cart=1
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('open_cart') === '1') {
    // Use a longer timeout to ensure all content is loaded
    setTimeout(openCartDrawerWhenReady, 1500);
  }
  
  // Check if URL is /cart_open
  if (window.location.pathname === '/cart_open') {
    // Use a longer timeout to ensure all content is loaded
    setTimeout(openCartDrawerWhenReady, 1500);
  }
  
  // Check if we need to open the cart drawer (from redirect)
  if (sessionStorage.getItem('openCartDrawer') === 'true') {
    sessionStorage.removeItem('openCartDrawer');
    // Use a longer timeout to ensure all content is loaded
    setTimeout(openCartDrawerWhenReady, 500);
  }
});

// Listen for cart drawer close and update URL
document.addEventListener('click', function(e) {
  if (e.target.closest('.drawer-close')) {
    // If drawer is being closed, change URL back to previous page
    history.back();
  }
});

